import React, { useState, useLayoutEffect, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { useStorage, useFlags } from 'utils';
import { Link, Row, Typography } from '../alf-design';
import { myslideLogo } from '../../assets/img';
import Background from './Background';
import { fb, insta, linkedin } from 'assets/icon';
import Footer from './Footer';

const PublicLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = queryString.parse(location.search);
  const [ready, setReady] = useState(null);
  const [, setIsMobile] = useStorage('isMobile', false);
  const { showComingSoon } = useFlags();
  const { pathname } = location;
  const currentYear = new Date().getFullYear();
  const login =
    pathname === '/' || pathname === '/create-account' ? true : false;

  const renderIcon = (icon, url) => (
    <Link href={url} target="_blank" rel="noopener noreferrer">
      <img
        alt={`${icon}-link`}
        src={icon}
        className="w-[24px] h-[24px] cursor-pointer"
      />
    </Link>
  );

  useEffect(() => {
    if (pathname !== '/create-account') {
      document.title = 'Online Policy Access for Slide Insurance Policyholders';
      const metaDescription = document.querySelector(
        'meta[name="description"]',
      );
      if (metaDescription) {
        metaDescription.setAttribute(
          'content',
          'Policy access is designed with you in mind. View your policy details, make payments, access your agent info, and more!',
        );
      }
    }
  }, [location]);

  useLayoutEffect(() => {
    if (params.error === 'sign_up_requested') {
      navigate('/create-account');
    }

    if (params.view === 'mobile') {
      setIsMobile(true);
    }
    if (params.view === 'web') {
      setIsMobile(false);
    }
    setReady(true);
  }, []);

  return (
    ready && (
      <Background
        isLanding={pathname === '/' || pathname === '/create-account'}
        fixedHeight={pathname === '/'}
      >
        <main
          id="public-main-content"
          role="main"
          className="flex flex-1 sm:block content-center items-center sm:items-start"
        >
          <div className="flex flex-col items-center w-full sm:w-auto">
            {showComingSoon ? (
              <>
                <Row>
                  <img
                    src={myslideLogo}
                    alt="mySlide"
                    className="h-[48px] w-auto mt-[100px]"
                  />
                </Row>
                <Row>
                  <Typography
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      height: 500,
                    }}
                    type="welcome"
                    component="h1"
                  >
                    Coming Soon
                  </Typography>
                </Row>
              </>
            ) : (
              <Outlet />
            )}
          </div>
        </main>
        <div className="block sm:hidden text-center px-[48px] py-[25px]">
          <Typography type="caption3" style={{ fontStyle: 'normal' }}>
            Difficulty logging in?
          </Typography>
          <Typography type="caption3" style={{ fontStyle: 'normal' }}>
            Call Us{' '}
            <a
              data-testid="callUs"
              href={`tel:800-748-2030`}
              className="underline"
              tabIndex="0"
            >
              (800) 748-2030
            </a>
          </Typography>
        </div>
        {login ? (
          <div className="hidden sm:block bg-legacy-white px-[108px]">
            <hr />
            <div className="flex justify-between pt-[30px] pb-[60px]">
              <div className="flex items-center gap-[4px]">
                <Typography type="caption1">
                  © Copyright {currentYear} Slide Insurance Holdings, Inc. All
                  rights reserved. |
                </Typography>
                <Typography
                  id="privacy-button"
                  type="link"
                  onClick={() =>
                    window.open('https://www.slideinsurance.com/privacy-policy')
                  }
                >
                  Privacy Policy
                </Typography>
                <Typography>|</Typography>
                <Typography
                  id="terms-button"
                  type="link"
                  onClick={() =>
                    window.open('https://www.slideinsurance.com/terms')
                  }
                >
                  Terms of Service
                </Typography>
              </div>

              <div className="flex gap-[12px]">
                {renderIcon(
                  linkedin,
                  'https://www.linkedin.com/company/slideinsurance',
                )}
                {renderIcon(insta, 'https://www.instagram.com/slideinsurance/')}
                {renderIcon(fb, 'https://www.facebook.com/SlideInsurance')}
              </div>
            </div>
          </div>
        ) : (
          <Footer maxWidth={pathname === 'page-not-found'} />
        )}
      </Background>
    )
  );
};

export default PublicLayout;
